import StyledLink from '../StyledLink'
import {
  MONITOR,
  MONITOR_CONFIG
} from '../routes'
import type { Props } from '../types'

const LinkToMonitorConfigs = ({
  children,
  isHyperlink
}: Props) =>
  <StyledLink
    isHyperlink={isHyperlink}
    to={`/${MONITOR}/${MONITOR_CONFIG}`}
  >
    {children}
  </StyledLink>

export default LinkToMonitorConfigs
